<template>
  <div>
    <b-spinner small v-if="loading" />

    <div v-else>
      <table class="table table-bordered">
        <tr v-for="(values, type) in roles" :key="type">
          <th class="text-nowrap">{{ roleDescriptions[type] }}</th>
          <td>
            <b-list-group>
              <b-list-group-item 
                v-for="(contributor, index) in values" :key="index" 
                :variant="contributor.ProtectionStatus.BlockForDelivery ? 'danger' : 'secondary'"
              >
                {{ contributor.Name1 }} {{ contributor.Name2 }} {{ contributor.Name3 }}
                <span 
                  v-if="contributor.ProtectionStatus.PortalDescription != '--'"
                  :class="{
                    'text-danger': contributor.ProtectionStatus.BlockForDelivery,
                    'font-weight-bold': contributor.ProtectionStatus.BlockForDelivery,
                  }"
                >
                  ({{ contributor.ProtectionStatus.PortalDescription | trim }})
                </span>
                <br />
                {{ contributor.RoleDetails }}
              </b-list-group-item>
            </b-list-group>
          </td>
        </tr>
      </table>

      <b-button v-if="editAccess" @click="showAdd = true">Add contributor</b-button>

      <contributor-add
          :holder="holder"
          v-model="showAdd"
          @add="addContributor"
        />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContributorList',
    components: {
      "contributor-add": () => import("@/components/ContributorAdd"),
    },
    data () {
      return {
        loading: false,
        showAdd: false,
        roles: {},
        roleDescriptions: {},
        changes: null
      }
    },
    props: {
      holder: [String, Object],
      holderId: String,
    },
    computed: {
      holderType () {
        if (!this.holder) return false
        if (this.holder.InstanceType) return this.holder.InstanceType
        return this.holder
      },
      editAccess () {
        return this.$root.$data.me.access.ED1
      },
      roleDefs() {
        return this.$root.$data.fieldDefs[this.holderType]['Contributors.Role'] 
      },
    },
    methods: {
      async addContributor(contributor, selected_roles) {
        this.loading = true

        const roles = Object.fromEntries(
          selected_roles.map((key) =>  [key, [contributor.ContributorID] ])
        )

        try {
          const response = await this.$http.put(
            this.holderType.toLowerCase()+'s/'+this.holderId+'/contributors',
            roles
          )

          this.roles = response.data
        } catch {
          this.$notify({
            type: 'error',
            text: 'An error occurred while saving. Please refresh the page and try again.'
          })
        } finally {
          this.loading = false
        }

      }
    },
    mounted () {
      this.loading = true

      this.$root.$data.fieldDefs[this.holderType]['Contributors.Role'].Options.forEach(role => {
        this.roleDescriptions[role.JsonValue] = role.Value
      })
      
      this.$http
        .get(this.holderType.toLowerCase()+'s/'+this.holderId+'/contributors')
        .then(response => {
            this.loading = false
            this.roles = response.data    
        }).catch(function () {
            this.roles = []
        })
    }
  }
</script>

<style lang="scss" scoped>
  
</style>